<template>
	<module-field :bind="$props">
		<span class="input-redactor">
			<redactor v-if="useRedactor" :format="this.field.specific_data" :module="module" v-model="inputVal" :placeholder="field.placeholder"></redactor>
			<textarea-autosize v-else v-model="inputVal" :placeholder="field.placeholder"></textarea-autosize>
		</span>
	</module-field>
</template>

<script>

import Redactor from '@/views/components/Redactor';

import CrudField from '@/mixins/CrudField';

export default {

	mixins: [ CrudField ],

	computed: {

		useRedactor() {
			return (this.field.specific_data && this.field.specific_data.toLowerCase() !== 'none');
		},

	},

	components: {
		Redactor,
	},
};
</script>
